module.exports = __webpack_public_path__ + "static/media/3.635e4791.jpg";